import styled from '@emotion/styled'
import { ssrWarning } from 'utils/emotion'
import { Table, Paragraph, Pill } from 'components/patterns'
import { themeColor } from 'utils/styles'

export const StyledTable = styled(Table)((props) => {
  const { groupIds = [] } = props
  return `
    &&&& {
      tr > td:first-child ${ssrWarning} {
        vertical-align: middle;
      }

      .ant-table-row td {
        overflow: visible;
      }

      // need to swap where the border is, to work with turning off visibility
      // for radios not the first of its class
      tr.ant-table-row td {
        border-bottom: none;
        border-top: 1px solid rgba(227, 229, 232, 1);
      }

      tr:first-of-type td {
        border-top: none;
      }

      tr:last-of-type td {
        border-bottom: 1px solid rgba(227, 229, 232, 1);
      }

      tbody > .rowStyle:hover >td{
        cursor:pointer;
        background:${themeColor('blueLight', props)};
      }
      
      tbody > .notAllowed:hover >td{
        cursor:not-allowed;
      }
      ${
        groupIds
          ? groupIds.reduce(
              (acc, groupId) => `
            ${acc}
            // emulate 'first-of-class' selector (doesn't exist)
            // https://philna.sh/blog/2018/03/18/css-first-of-class/
            .${groupId} td:first-of-type {
              visibility: visible;
              border-bottom: none;
              border-top: 1px solid rgba(227,229,232,1);
            }
            .${groupId} + .${groupId} td:first-of-type { visibility: hidden; }
          `,
              ''
            )
          : ''
      }
    }
  `
})

export const StyledDiv = styled.div`
  && {
    overflow-x: inherit;
  }
  position: relative;
  display: flex;

  svg {
    margin-left: 10px;
  }
`

export const StyledParagraph = styled(Paragraph, {
  shouldForwardProp: (passedInProp) => passedInProp !== 'hasError',
})((props) => {
  const { hasError, theme } = props
  const { paragraphErrorColor } = theme

  if (hasError) return `color: ${paragraphErrorColor};`

  return ``
})

export const StyledPill = styled(Pill)`
  align-items: center;
  border-radius: 15px;
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  height: auto;
  margin: 0;
  padding: 2px 5px;
  position: relative;
  text-transform: uppercase;
  top: -2px;
  width: auto;
`
